import { DIVISIONS, MEDIA_CATS } from "@/lib/content";

const DIV = DIVISIONS.map((d) => ({ value: d.slug, label: d.name }));
const opts = (arr) => arr.map((v) => ({ value: v, label: v }));

export const SCHEMAS = {
  announcements: {
    label: "Announcements", cols: ["title", "category", "date"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "body", label: "Announcement", type: "textarea" },
      { k: "category", label: "Category", type: "select", options: opts(["General", "Tryouts", "Events", "Teams", "Parents"]) },
      { k: "date", label: "Date", type: "date" },
      { k: "link_url", label: "Link URL (optional)", type: "text" },
      { k: "pinned", label: "Highlight / pin to top", type: "bool" },
      { k: "published", label: "Public", type: "bool", default: true },
    ],
  },
  athletes: {
    label: "Athletes", cols: ["name", "division", "position", "jersey"],
    fields: [
      { k: "name", label: "Athlete Name", type: "text", required: true },
      { k: "photo_url", label: "Photograph", type: "image" },
      { k: "division", label: "Age Division", type: "select", options: DIV, coachLocked: true },
      { k: "position", label: "Position", type: "text" },
      { k: "jersey", label: "Jersey Number", type: "text" },
      { k: "home_org", label: "Home Football Organization", type: "text" },
      { k: "accomplishments", label: "Football Accomplishments (one per line)", type: "textarea" },
      { k: "bio", label: "Short Bio", type: "textarea" },
      { k: "media_url", label: "Featured Media (YouTube/Vimeo link or upload video)", type: "media" },
      { k: "featured", label: "Featured athlete", type: "bool" },
      { k: "spotlight_week", label: "Weekly Spotlight (e.g. Week of Nov 2)", type: "text" },
      { k: "guardian_consent", label: "Parent/guardian permission on file (required to display publicly)", type: "bool" },
      { k: "published", label: "Public", type: "bool", default: true },
    ],
  },
  invitations: {
    label: "Invitations", cols: ["title", "athlete_name", "division"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "athlete_name", label: "Athlete Name", type: "text" },
      { k: "division", label: "Division", type: "select", options: DIV },
      { k: "image_url", label: "Invitation Graphic", type: "image" },
      { k: "published", label: "Public (confirm guardian permission)", type: "bool", default: true },
    ],
  },
  teams: {
    label: "Teams", cols: ["name", "head_coach"],
    fields: [
      { k: "name", label: "Division Name", type: "text", required: true, adminOnly: true },
      { k: "slug", label: "URL Slug (e.g. 9u)", type: "text", adminOnly: true },
      { k: "order", label: "Display Order", type: "number", adminOnly: true },
      { k: "head_coach", label: "Head Coach", type: "text" },
      { k: "head_coach_photo", label: "Head Coach Photo", type: "image" },
      { k: "head_coach_bio", label: "Head Coach Profile", type: "textarea" },
      { k: "assistants", label: "Assistant Coaching Staff", type: "rows", columns: [["name", "Name"], ["role", "Role"]] },
      { k: "practice_info", label: "Practice Information", type: "textarea" },
      { k: "schedule", label: "Team Schedule", type: "rows", columns: [["date", "Date"], ["time", "Time"], ["opponent", "Opponent / Event"], ["location", "Location"]] },
      { k: "results", label: "Tournament Results", type: "rows", columns: [["event", "Event"], ["result", "Result"]] },
      { k: "team_photo", label: "Team Photo", type: "image" },
      { k: "gallery", label: "Team Photo Gallery", type: "images" },
      { k: "roster_public", label: "Show roster publicly", type: "bool", default: true },
    ],
  },
  events: {
    label: "Events", cols: ["title", "date", "location"],
    fields: [
      { k: "title", label: "Event Title", type: "text", required: true },
      { k: "slug", label: "URL Slug (e.g. aug-florida-showcase)", type: "text" },
      { k: "date", label: "Date", type: "date" },
      { k: "time_info", label: "Time Info", type: "text" },
      { k: "category", label: "Category", type: "select", options: opts(["Tryouts", "Showcase", "National", "Practice", "Other"]) },
      { k: "location", label: "Location", type: "text" },
      { k: "address", label: "Address (for directions)", type: "text" },
      { k: "description", label: "Event Information", type: "textarea" },
      { k: "participating_teams", label: "Participating Teams (one per line)", type: "list" },
      { k: "schedule", label: "Game Schedule", type: "rows", columns: [["time", "Time"], ["matchup", "Matchup"], ["field", "Field"]] },
      { k: "scores", label: "Scores", type: "rows", columns: [["division", "Division"], ["home", "Team A"], ["home_score", "Score"], ["away", "Team B"], ["away_score", "Score"]] },
      { k: "results", label: "Tournament Results", type: "textarea" },
      { k: "gallery", label: "Photo Gallery", type: "images" },
      { k: "videos", label: "Video Highlight Links (one per line)", type: "list" },
      { k: "published", label: "Public", type: "bool", default: true },
    ],
  },
  articles: {
    label: "Media", cols: ["title", "category", "date"],
    fields: [
      { k: "title", label: "Headline", type: "text", required: true },
      { k: "category", label: "Section", type: "select", options: opts(MEDIA_CATS) },
      { k: "date", label: "Date", type: "date" },
      { k: "author", label: "Author", type: "text" },
      { k: "excerpt", label: "Summary", type: "textarea" },
      { k: "body", label: "Article Body", type: "textarea", rows: 10 },
      { k: "cover_url", label: "Cover Photo", type: "image" },
      { k: "video_url", label: "Video (YouTube/Vimeo link or upload)", type: "media" },
      { k: "gallery", label: "Photo Gallery", type: "images" },
      { k: "featured", label: "Top story", type: "bool" },
      { k: "published", label: "Public", type: "bool", default: true },
    ],
  },
  sponsors: {
    label: "Sponsors", cols: ["name", "level"],
    fields: [
      { k: "name", label: "Sponsor Name", type: "text", required: true },
      { k: "logo_url", label: "Logo", type: "image" },
      { k: "website", label: "Website", type: "text" },
      { k: "level", label: "Partnership Type", type: "text" },
      { k: "announcement", label: "Partnership Announcement", type: "textarea" },
      { k: "published", label: "Approved & public", type: "bool", default: true },
    ],
  },
  board: {
    label: "Board Members", cols: ["name", "title"],
    fields: [
      { k: "name", label: "Name", type: "text", required: true },
      { k: "title", label: "Board Position", type: "text" },
      { k: "contact_for", label: "'Who to contact' topic (e.g. Payments and finances)", type: "text" },
      { k: "bio", label: "Short Biography", type: "textarea" },
      { k: "responsibilities", label: "Primary Responsibilities (one per line)", type: "list" },
      { k: "message", label: "Personal Message to Parents (optional)", type: "textarea" },
      { k: "photo_url", label: "Photo (use Board Photo Manager to crop)", type: "image" },
      { k: "order", label: "Display Order (0 = first)", type: "number" },
      { k: "published", label: "Public", type: "bool", default: true },
    ],
  },
  portal_updates: {
    label: "Portal Updates", cols: ["title", "team_slug", "date"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "body", label: "Private Update", type: "textarea" },
      { k: "team_slug", label: "Audience", type: "select", options: [{ value: "all", label: "All Families" }, ...DIV], coachLocked: true },
      { k: "date", label: "Date", type: "date" },
    ],
  },
};

export const SETTINGS_GROUPS = [
  ["Registration Links", [{ k: "jotform_url", label: "Jotform Player Registration URL", type: "text" }, { k: "eventbrite_url", label: "Eventbrite URL", type: "text" }]],
  ["Branding", [{ k: "logo_url", label: "Organization Logo", type: "image" }, { k: "hero_image_url", label: "Homepage Hero Photo", type: "image" }]],
  ["Homepage", [
    { k: "hero_headline", label: "Hero Headline", type: "text" },
    { k: "hero_subheading", label: "Hero Subheading", type: "text" },
    { k: "ticker_text", label: "Announcement Ticker", type: "text" },
    { k: "tryout_datetime", label: "Tryout Countdown (ISO, e.g. 2026-10-25T10:00:00-04:00)", type: "text" },
    { k: "mission_text", label: "Mission Statement", type: "textarea" },
  ]],
  ["Leadership", [{ k: "coach_kp_photo", label: "Coach KP Photo", type: "image" }, { k: "coach_kp_bio", label: "Coach KP Profile", type: "textarea" }]],
  ["Social Media", ["facebook", "instagram", "youtube", "tiktok", "x"].map((s) => ({ k: `${s}_url`, label: `${s === "x" ? "X / Twitter" : s[0].toUpperCase() + s.slice(1)} URL`, type: "text" }))],
];
